import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert-popup',
  templateUrl: './alert-popup.component.html',
  styleUrls: ['./alert-popup.component.scss'],
})
export class AlertPopupComponent implements OnInit {
  popupVisible: boolean = true;

  constructor() {}

  ngOnInit(): void {}

  closePopup() {
    this.popupVisible = false;
  }
}
